import { render, staticRenderFns } from "./ProfessionalCategorySingle.vue?vue&type=template&id=00be66fc&scoped=true"
import script from "./ProfessionalCategorySingle.vue?vue&type=script&lang=js"
export * from "./ProfessionalCategorySingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00be66fc",
  null
  
)

export default component.exports